import { useCallback, useState } from './index'


const useTabs = ({ selected, onSelect } = {}) => {
  const [ selectedTab, setSelectedTab ] = useState(selected || 0)

  const selectTab = useCallback((newSelected) => {
    if (typeof onSelect === 'function') {
      onSelect(newSelected)
    }

    setSelectedTab(newSelected)
  }, [ onSelect ])

  return {
    selectedTab,
    selectTab,
  }
}


export default useTabs
